import { OverlayVideoController } from "./overlay-video.controller";

angular
    .module("thor.shared.overlay-video.component", [])
    .component("thorOverlayVideo", {
        controller: OverlayVideoController,
        controllerAs: "overlayVideoCtrl",
        template: require("../../shared/overlay-video/overlay-video.html")
    });
